import queryString from 'query-string';
import { useWtrDispatch } from 'redux/hooks';
import env from 'env/env';
import history from 'utils/history';
import { SAVE_LAST_NON_AUTHENTICATION_PATH } from './types';

export const useSaveNewPathForPostAuthNavigation = () => {
  const dispatch = useWtrDispatch();

  const saveNewPathForPostAuthNavigation = ({
    customPathname,
    customSearch,
  }: {
    customPathname?: string;
    customSearch?: string;
  }) => {
    const { pathname, search } = history.getLocation();

    dispatch({
      type: SAVE_LAST_NON_AUTHENTICATION_PATH,
      payload: {
        location: {
          pathname: customPathname || pathname,
          search: customSearch || search,
        },
      },
    });
  };

  return saveNewPathForPostAuthNavigation;
};

export const saveLastNonAuthenticationPath = (): WtrThunkAction<void> => dispatch => {
  const { search } = history.getLocation();
  const { redirect } = queryString.parse(search);

  if (redirect) {
    const { pathname, search: redirectSearch } = new URL(redirect, env.clientHost);

    dispatch({
      type: SAVE_LAST_NON_AUTHENTICATION_PATH,
      payload: {
        location: { pathname, search: redirectSearch },
      },
    });
  }
};
